import styled from "styled-components"

export const FooterWrapp = styled.section`
  background: #28342f;
  color: #f7f5f0;
  padding: 44px 0 28px;

  .content-footer {
    display: grid;
    grid-template-columns: 1.2fr 0.7fr 1fr;
    gap: 32px;
    margin-bottom: 28px;

    .about {
      max-width: 280px;

      p {
        color: #c7d0c7;
        font-size: 13px;
      }

      .logos {
        margin-top: 16px;
        display: flex;
        align-items: center;
        gap: 10px;

        .text {
          font-weight: 600;
          margin-left: 0;
          color: #f7f5f0;
        }

        img {
          width: 22px;
        }
      }
    }

    .logo {
      display: flex;
      align-items: center;
      margin-bottom: 12px;

      img {
        width: 36px;
      }

      h1 {
        margin: 0 0 0 10px;
        font-size: 18px;
      }
    }

    h1 {
      margin-bottom: 10px;
      font-size: 15px;
      color: #ffffff;
    }

    .navigation {
      a {
        color: #c7d0c7;
        font-size: 13px;

        &:hover {
          color: #ffffff;
        }
      }
    }

    .address {
      max-width: 350px;

      p {
        color: #c7d0c7;
        font-size: 13px;
      }
    }

    @media (max-width: 768px) {
      grid-template-columns: auto auto
    }
    @media (max-width: 426px) {
      grid-template-columns: auto
    }
  }

  .copyright {
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    color: #aab5ab;
  }
`
